export default __webpack_public_path__ + "static/media/icn-triangle-down.828daf8b.svg";